


const speedMarker = (speed, color) => {

    const svg = `
      <svg width="30" height="30" xmlns="http://www.w3.org/2000/svg">
        <circle cx="15" cy="15" r="12" fill="${color}" />

        <text x="15" y="18" font-size="10" text-anchor="middle" fill="white" font-family="Arial">${speed}</text>
      </svg>
  `;
  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
}

export default speedMarker